import { AdminStatusType, AuditorStatusType } from "../../../../utils/enums";

export const calculateControlStats = (audit, controls = []) => {
  if (!audit) {
    return {
      totalControls: 0,
      approved: 0,
      flagged: 0,
    };
  }

  // Count controls by their status
  let approved = 0;
  let flagged = 0;

  controls.forEach((control) => {
    // Status counts
    if (control.status === AuditorStatusType.APPROVED) {
      approved++;
    }

    // Flag counts - using separate boolean field
    if (control.redFlag) {
      flagged++;
    }
  });

  return {
    totalControls: audit.total_controls || 0,
    approved,
    flagged,
  };
};


export const calculateProgressPercentage = (stats) => {
  const { totalControls, approved } = stats;
  
  if (totalControls === 0) return 0;
  
  return Math.round((approved / totalControls) * 100);
};

/**
 * Find the index of the current active milestone
 * @param {Array} milestones - Array of milestone objects
 * @returns {Number} - Index of the active milestone
 */
export const getActiveMilestoneIndex = (milestones) => {
  const safeMilestones = Array.isArray(milestones) ? milestones.filter(Boolean) : [];
  if (safeMilestones.length === 0) return 0;

  const currentMilestoneIndex = safeMilestones.findIndex(
    (m) => !m.isCompleted
  );
  return currentMilestoneIndex === -1
    ? safeMilestones.length - 1
    : currentMilestoneIndex;
};
